import { render } from "./InjuryTrendChart.vue?vue&type=template&id=7f797f5e&scoped=true"
import script from "./InjuryTrendChart.vue?vue&type=script&lang=js"
export * from "./InjuryTrendChart.vue?vue&type=script&lang=js"

import "./InjuryTrendChart.vue?vue&type=style&index=0&id=7f797f5e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f797f5e"]])

export default __exports__